// External Dependencies:
import React from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

// Internal Dependencies:
import PostTile from 'church-theme-library/components/PostTile/PostTile'
import { formattedDate } from 'church-theme-library/utilities/date'

// Redux:
import { closeSearch } from 'church-theme-library/redux/actions/search'

const host = window.location.host

class SearchResult extends React.Component {
	closeSearch = () => {
		const { dispatch } = this.props

		dispatch( closeSearch() )
	}

	handleResultClick = ( e ) => {
		const { dispatch, history } = this.props

		let href = e.currentTarget.getAttribute( 'href' )
		href = href.replace( /^(\.+)/g, '' )

		if ( href.indexOf( host ) > -1 && href.indexOf( '//' ) > -1 ) {
			window.location( href ) // Same network, different site, open normally.
		} else if ( href.indexOf( '//' ) > -1 ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 ) // Anchor within this page.
			window.location.hash = hash
		} else {
			history.push( href ) // Same site, use router.

			this.closeSearch()
		}

		e.preventDefault()
	}

	render() {
		const { searchResult, mostRelevant, isMobile } = this.props

		return (
			<div className="-item-wrap">
				{ ( isMobile && mostRelevant ) &&
					<PostTile
						key={ searchResult.id }
						url={ searchResult.url }
						title={ searchResult.title }
						author={ searchResult.author }
						date={ formattedDate( searchResult ) }
						image={ searchResult.featured_image }
						imageAlt={ searchResult.title }
						onClick={ this.handleResultClick }
						direction="vertical"
						size="small"
					/>
				|| isMobile &&
					<PostTile
						key={ searchResult.id }
						url={ searchResult.url }
						title={ searchResult.title }
						author={ searchResult.author }
						date={ formattedDate( searchResult ) }
						image={ searchResult.featured_image }
						imageAlt={ searchResult.title }
						onClick={ this.handleResultClick }
						direction="horizontal"
						size="small"
						order="text-image"
					/>
				||
					<PostTile
						key={ searchResult.id }
						url={ searchResult.url }
						title={ searchResult.title }
						author={ searchResult.author }
						date={ formattedDate( searchResult ) }
						image={ searchResult.featured_image }
						imageAlt={ searchResult.title }
						onClick={ this.handleResultClick }
						direction="vertical"
						size="medium"
					/>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchResults: state.search.searchResults,
		isMobile: state.site.isMobile
	}
}

export default withRouter(
	connect( mapStateToProps )( SearchResult )
)
